//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Map from '@/assets/image/map.jpg';
import CustomDrawer from '@/components/CustomDrawer.vue';

var os = (function() {
    var ua = navigator.userAgent;
    var isWindowsPhone = /(?:Windows Phone)/.test(ua);
    var isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
    var isAndroid = /(?:Android)/.test(ua);
    var isFireFox = /(?:Firefox)/.test(ua);
    var isChrome = /(?:Chrome|CriOS)/.test(ua);
    var isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
    var isPhone = /(?:iPhone)/.test(ua) && !isTablet;
    var isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
}());

export default {
    components: { CustomDrawer },
    data() {
        return {
            map: '',
            level: 12,
            dialog: {
                show: false,
                content: ''
            },
            entities: [],
            os: os
        };
    },
    mounted() {
        this.getEntities().then(res => {
            if (res) {
                this.initMap();
            }
        });
    },
    methods: {
        getEntities() {
            return this.axios({
                url: '/article/listPage',
                data: {
                    categoryId: 8,
                    pageSize: 100,
                    pageNum: 1,
                    language: this.i18n
                }
            }).then(res => {
                if (res) {
                    this.entities = res.data.data;
                    return true;
                }
                return false;
            });
        },
        initMap() {
            var map = window.L.map('map', {
                center: [-1168 / 5000, 5682 / 5000],
                zoom: this.level,
                minZoom: this.level,
                maxZoom: 14,
                zoomControl: false,
                attributionControl: false,
                maxBounds: [[0, 0], [-0.9, 1.6]],
                bounceAtZoomLimits: false
            });

            var imageUrl = Map; var imageBounds = [[0, 0], [-0.9, 1.6]];
            window.L.imageOverlay(imageUrl, imageBounds).addTo(map);
            this.map = map;
            this.map.on('zoomend', (eve) => {
                const level = eve.target._animateToZoom;
                var i = level - this.level;
                this.level = level;
                this.entities.forEach(item => {
                    if (i >= 0) {
                        item.width = item.width * ((+i) * 2);
                        item.height = item.height * ((+i) * 2);
                    } else {
                        item.width = item.width / ((-i) * 2);
                        item.height = item.height / ((-i) * 2);
                    }
                    item.el.style.width = item.width + 'px';
                    item.el.style.height = item.height + 'px';
                });
            });
            this.drawEntity();
        },
        showMsg(data) {
            this.dialog.content = data;
            this.dialog.show = true;
        },
        drawEntity() {
            const div = document.createElement('div');
            for (let i = 0; i < this.entities.length; i++) {
                const e = this.entities[i];
                // 默认只显示游
                const x = e.x / 5000;
                const y = e.y / 5000;
                var el = `<div class="entity" style="width: ${e.width}px; height: ${e.height}px;" data-type='${e.type_id}' data-value='${i}' x='${x}' y='${-y}'></div>`;
                div.innerHTML = el;
                el = div.firstChild;
                e.el = el;
                el.addEventListener('click', (eve) => {
                    this.showMsg(e);
                    this.map.setView([-y, x]);
                });
                const myIcon = window.L.divIcon({
                    html: el
                });
                window.L.marker([-y, x], { icon: myIcon }).addTo(this.map);
            }
        },
        overview() {
            window.open(this.dialog.content.url, 'blank');
        }
    }
};
